import React from 'react';
import classNames from 'classnames';

const Curtain = ({ changeView, view, restartQuiz }) =>  {

  return (

      <div>
          <div className="curtain curtain--loading js-curtain-loading">
              <div className="curtain__content">

                  <svg className="curtain__logo" viewBox="0 0 27.6 24.2">
                      <use xlinkHref="#VAL_logo"></use>
                  </svg>
                  <h1 className="scene__tagline">Give <span>the</span> Gift <span>of</span> Games</h1>

                  <div className="curtain__loading"></div>
              </div>
          </div>

          <div className="curtain curtain--transition js-curtain-transition">
              <div className="curtain__content">
                  <div className="curtain__loading"></div>
              </div>
          </div>
          <div className="curtain curtain--result js-curtain-result">
              <div className="curtain__content">
                  <h1 className="curtain__headline">Finding your gift now!</h1>
                  <p className="scene__p"><small>Please wait while we select the perfect gift for you.</small></p>
                  <div className="curtain__loading"></div>
              </div>
          </div>
          <div className="curtain curtain--transition js-curtain-quiz-start">
              <div className="curtain__content">
                  <h1 className="curtain__headline">Starting your quiz now!</h1>
                  <div className="curtain__loading"></div>
              </div>
          </div>
      </div>
  );
}

export default Curtain;



/** WEBPACK FOOTER **
 ** ./src/components/Curtain/Curtain.js
 **/